var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 61,
    viewBox: "0 0 201 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_724_66413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6099 36.048L35.9083 16.8387H34.7937L28.119 34.6502H28.0526L21.3779 16.8387H20.25L27.5484 36.048H28.6099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9253 36.048H38.9604V21.7109H37.9253V36.048ZM38.4428 18.1965C38.9073 18.1965 39.2788 17.8371 39.2788 17.3845C39.2788 16.9185 38.9073 16.5591 38.4428 16.5591C37.9917 16.5591 37.6201 16.9185 37.6201 17.3845C37.6201 17.8371 37.9917 18.1965 38.4428 18.1965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6388 36.2344C50.2927 36.2344 52.3628 34.5038 53.0263 32.1875H53.0661V36.048H54.0348V16H52.9998V25.4915H52.9732C52.3363 23.2551 50.2662 21.5245 47.6255 21.5245C44.056 21.5245 41.5347 24.5064 41.5347 28.8861C41.5347 33.2525 44.0692 36.2344 47.6388 36.2344ZM47.7582 22.4697C50.8235 22.4697 53.013 25.0922 53.013 28.8861C53.013 32.6667 50.8235 35.3025 47.7582 35.3025C44.7062 35.3025 42.583 32.7067 42.583 28.8728C42.583 25.0522 44.7062 22.4697 47.7582 22.4697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8592 22.4564C65.8714 22.4564 67.915 24.7727 67.9282 28.1672H57.6707C57.83 24.746 59.8868 22.4564 62.8592 22.4564ZM67.7557 32.0411C67.3444 33.9181 65.606 35.3025 62.9919 35.3025C59.7806 35.3025 57.6575 33.0128 57.6575 29.0991V29.0458H68.9766V28.4468C68.9766 24.2801 66.5615 21.5245 62.8725 21.5245C59.1039 21.5245 56.6091 24.4532 56.6091 28.8994C56.6091 33.5054 59.1039 36.2344 62.9786 36.2344C66.1368 36.2344 68.3396 34.4639 68.8041 32.0411H67.7557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0578 36.2344C80.8663 36.2344 83.4273 33.3856 83.4273 28.8861C83.4273 24.3733 80.8663 21.5245 77.0578 21.5245C73.2627 21.5245 70.7016 24.3733 70.7016 28.8861C70.7016 33.3856 73.2494 36.2344 77.0578 36.2344ZM77.0578 35.3025C73.8466 35.3025 71.7367 32.8398 71.7367 28.8861C71.7367 24.9191 73.8466 22.4697 77.0578 22.4697C80.2691 22.4697 82.379 24.9191 82.379 28.8861C82.379 32.8265 80.2691 35.3025 77.0578 35.3025Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.62 18.8089H101.687L106.782 36.048H107.711L113.059 16.8387H111.957L107.247 34.2242H107.18L102.138 16.8387H101.156L96.1265 34.2242H96.0601L91.3361 16.8387H90.248L95.5957 36.048H96.5246L101.62 18.8089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.341 36.048H116.376V21.7109H115.341V36.048ZM115.859 18.1965C116.323 18.1965 116.695 17.8371 116.695 17.3845C116.695 16.9185 116.323 16.5591 115.859 16.5591C115.407 16.5591 115.036 16.9185 115.036 17.3845C115.036 17.8371 115.407 18.1965 115.859 18.1965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.667 36.048H120.702V27.515C120.702 24.533 122.586 22.4697 125.386 22.4697C128.054 22.4697 129.805 24.1337 129.805 26.9159V36.048H130.84V26.7961C130.84 23.5746 128.757 21.5245 125.612 21.5245C123.184 21.5245 121.339 22.8557 120.676 24.8659H120.636V21.7109H119.667V36.048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.306 36.2344C141.96 36.2344 144.03 34.5038 144.694 32.1875H144.734V36.048H145.702V16H144.667V25.4915H144.641C144.004 23.2551 141.934 21.5245 139.293 21.5245C135.723 21.5245 133.202 24.5064 133.202 28.8861C133.202 33.2525 135.737 36.2344 139.306 36.2344ZM139.426 22.4697C142.491 22.4697 144.681 25.0922 144.681 28.8861C144.681 32.6667 142.491 35.3025 139.426 35.3025C136.374 35.3025 134.251 32.7067 134.251 28.8728C134.251 25.0522 136.374 22.4697 139.426 22.4697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.633 36.2344C158.441 36.2344 161.002 33.3856 161.002 28.8861C161.002 24.3733 158.441 21.5245 154.633 21.5245C150.838 21.5245 148.277 24.3733 148.277 28.8861C148.277 33.3856 150.824 36.2344 154.633 36.2344ZM154.633 35.3025C151.422 35.3025 149.312 32.8398 149.312 28.8861C149.312 24.9191 151.422 22.4697 154.633 22.4697C157.844 22.4697 159.954 24.9191 159.954 28.8861C159.954 32.8265 157.844 35.3025 154.633 35.3025Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.748 21.7109H179.66L175.984 34.8899H175.944L171.95 21.7109H170.782L166.788 34.8899H166.748L163.072 21.7109H161.984L166.151 36.048H167.359L171.353 23.0554H171.379L175.374 36.048H176.581L180.748 21.7109Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_724_66413",
    x: 0.25,
    y: 0,
    width: 200.496,
    height: 60.2344,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_724_66413"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_724_66413",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/white-logo.ccd8346e7a983ebaba1b62ae81f9de83.svg";
export { ForwardRef as ReactComponent };